import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '../../../shared/model/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApprovalService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getSupportRequests (supportDepartmentID?: number, status?: any, userKeyID?: number) {
    var url = "/Approval/GetSupportRequests?supportDepartmentID=" + supportDepartmentID
      + "&status=" + status + "&userKeyID=" + userKeyID
    return this.http.get(url).toPromise();
  }

  getHRList (searchText?: string, includeInactive?: string, userKeyID?: number) {
    var url = "/Approval/GetHRList?searchText=" + searchText + "&includeInactive=" + includeInactive + "&userKeyID=" + userKeyID;
    return this.http.get(url).toPromise();
  }

  updateRequest (supportRequestID: number, supportDepartmentID: number, requestStatus: string, assignedToUserKeyID: number, submittedByUserKeyID: number, isUrgent: boolean) {
    return this.http.post("/Approval/UpdateRequest", {
      supportRequestID: supportRequestID,
      supportDepartmentID: supportDepartmentID,
      requestStatus: requestStatus,
      assignedToUserKeyID: assignedToUserKeyID,
      submittedByUserKeyID: submittedByUserKeyID,
      isUrgent: isUrgent
    }).toPromise();
  }

  getRequestByID (supportRequestID: number) {
    var url = "/Approval/GetRequestByID?supportRequestID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  getSupportNotes (supportRequestID: number) {
    var url = "/Approval/GetSupportNotes?supportRequestID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  addSupportNote (supportRequestID: number, supportNote: string, isNotify: boolean) {
    return this.http.post("/Approval/AddSupportNote", {
      supportRequestID: supportRequestID,
      supportNote: supportNote,
      isNotify: isNotify
    }).toPromise();
  }

  getAssestsByEmployee (supportRequestID: number) {
    var url = "/Approval/GetAssestsByEmployee?supportRequestID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  getAttachmentsByRequestID (supportRequestID: number) {
    var url = "/Approval/GetAttachmentsByRequestID?moduleID=" + 13 + "&recordID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  dependentRequestAction (dependentRequestID: number, postData: any, actionCode: string, actionNotes?: any) {
    return this.http.post("/Approval/DependentRequestAction",
      {
        dependentRequestID: dependentRequestID,
        formData: postData,
        actionCode: actionCode,
        actionNotes: actionNotes
      }).toPromise();
  }

  saveWindowAuditReportData (benefitUserWindowID: number) {
    return this.http.post("/Approval/SaveWindowAuditReportData",
      {
        benefitUserWindowID: benefitUserWindowID
      }).toPromise();
  }

  getWindowHistory (hRUserKeyID: number) {
    var url = "/Approval/GetWindowHistory?hRUserKeyID=" + hRUserKeyID;
    return this.http.get(url).toPromise();
  }

  getBenefitsDashboardFilterValues (pRCo: number, pRGroup?: number, addlFilterName?: string) {
    var url = "/Approval/GetBenefitsDashboardFilterValues?pRCo=" + pRCo + "&pRGroup=" + pRGroup + "&addlFilterName=" + addlFilterName;
    return this.http.get(url).toPromise();
  }

  getBenefitsDashboard (pRCo: number, pRGroup?: number, earnCode?: number, craft?: string, pRDept?: string, benefitGroup?: string, windowTypeID?: number, status?: string, active?: string) {
    var url = "/Approval/GetBenefitsDashboard?pRCo=" + pRCo + "&pRGroup=" + pRGroup + "&earnCode=" + earnCode + "&craft=" + craft + "&pRDept=" + pRDept + "&benefitGroup=" + benefitGroup + "&windowTypeID=" + windowTypeID + "&status=" + status + "&Active=" + active;
    return this.http.get(url).toPromise();
  }

  initializeUserWindow (userKeyIDString: string, pRCo: number, windowStartDateString: string, windowEndDateString: string,
    windowTypeID: number, requestedEffectiveDateStr: string) {
    return this.http.post("/Approval/InitializeUserWindow",
      {
        userKeyIDString: userKeyIDString,
        pRCo: pRCo,
        windowStartDateString: windowStartDateString,
        windowEndDateString: windowEndDateString,
        windowTypeID: windowTypeID,
        requestedEffectiveDateStr: requestedEffectiveDateStr
      }).toPromise();
  }

  sendEnrollmentReminder (benefitUserWindowIDString: string, pRCo: number) {
    return this.http.post("/Approval/SendEnrollmentReminder",
      {
        benefitUserWindowIDString: benefitUserWindowIDString,
        pRCo: pRCo
      }).toPromise();
  }

  benefitCodeAudit (userKeyID: number) {
    var url = "/Approval/BenefitCodeAudit?userKeyID=" + userKeyID;
    return this.http.get(url).toPromise();
  }

  checkBenefitSummaryReport (userKeyIDString: string, startDateStr: string, endDateStr: string) {
    return this.http.post("/Approval/CheckBenefitSummaryReport",
      {
        userKeyIDString: userKeyIDString,
        startDateStr: startDateStr,
        endDateStr: endDateStr
      }).toPromise();
  }

  getPendingBenefitsRequests (pRCo: number, pRGroup?: number, earnCode?: number, craft?: string, pRDept?: string, benefitGroup?: string, windowTypeID?: number) {
    var url = "/Approval/GetPendingBenefitsRequests?pRCo=" + pRCo + "&pRGroup=" + pRGroup + "&earnCode=" + earnCode + "&craft=" + craft + "&pRDept=" + pRDept +
      "&benefitGroup=" + benefitGroup + "&windowTypeID=" + windowTypeID;
    return this.http.get(url).toPromise();
  }

  benefitRequestAction (isApproved: boolean, benefitRequestID: any, notes: string, effectiveDateString: string) {
    return this.http.post("/Approval/BenefitRequestAction",
      {
        isApproved: isApproved,
        benefitRequestID: benefitRequestID,
        notes: notes,
        effectiveDateString: effectiveDateString
      }).toPromise();
  }


  getPendingDependentRequests (status: string) {
    var url = "/Approval/GetPendingDependentRequests?status=" + status;
    return this.http.get(url).toPromise();
  }

  getDBAttachmentList (moduleID: number, recordID: number) {
    var url = "/Document/GetDBAttachmentList?moduleID=" + moduleID + "&recordID=" + recordID;
    return this.http.get(url).toPromise();
  }

  approveVacation (leaveRequestId?: number, actionNotes?: string) {
    return this.http.post("/Approval/ApproveVacation", {
      leaveRequestId: leaveRequestId,
      actionNotes: actionNotes
    }).toPromise();
  }

  rejectVacation (leaveRequestId?: number, actionNotes?: string) {
    return this.http.post("/Approval/RejectVacation", {
      leaveRequestId: leaveRequestId,
      actionNotes: actionNotes
    }).toPromise();
  }

  getServerBasedDate () {
    var url = "/Approval/GetServerBasedDate";
    return this.http.get(url).toPromise();
  }

  getRejectReasons(module: string) {
    let url = "/APRouter/GetRejectReasons?module=" + module;
    return this.http.get(url).toPromise();
  }

  getTimecardApprovalJobs(pRPCKeyID, approvalStatus = null) {
    let url = "/Approval/GetTimecardApprovalJobs?pRPCKeyID=" + pRPCKeyID;
    if (approvalStatus != null)
      url += "&approvalStatus=" + approvalStatus;
    return this.http.get(url).toPromise();
  }

  getPayPeriods(company: any, isManager?: boolean) {
    var url = "/Approval/GetPayPeriods?company=" + company;
    if (isManager != null) {
      url += "&isManager=" + isManager;
    }
    return this.http.get(url).toPromise();
  }

  getTimecardSummary (hQBCKeyID: number, pRPCKeyID: number, isManager?: boolean, filterResults?: boolean) {
    var url = "/Approval/GetTimecardSummary?pRPCKeyID=" + pRPCKeyID + "&hQBCKeyID=" + hQBCKeyID;
    if (isManager != null) {
      url += "&isManager=" + isManager;
    }
    if (filterResults != null) {
      url += "&filterResults=" + filterResults;
    }
    return this.http.get(url).toPromise();
  }

  getUnapprovedJobTimecardLines () {
    var url = "/Approval/GetUnapprovedJobTimecardLines";
    return this.http.get(url).toPromise();
  }

  approveTimecard (requestData: any) {
    return this.http.post("/Approval/ApproveTimecard", requestData).toPromise();
  }

  rejectTimecard (requestData: any) {
    return this.http.post("/Approval/RejectTimecard", requestData).toPromise();
  }


  getPOPendingItemsToReview (): Promise<PendingPO[]> {
    const url = "/approval/GetPOPendingItemsToReview";
    return this.http.get<Array<PendingPO>>(url).toPromise();
  }

  pOPendingUpdateStatus (status?: number, wFProcessDetailKeyIDs?: number[], reviewerComments?: string): Promise<POPendingUpdateStatusResponse> {
    return this.http.post<POPendingUpdateStatusResponse>("/Approval/POPendingUpdateStatus", {
      status: status,
      wFProcessDetailKeyIDs: wFProcessDetailKeyIDs,
      reviewerComments: reviewerComments
    }).toPromise();
  }

  getPOPendingGetAttachments(headerUniqueAttchID?: any, itemUniqueAttchID?: any){
    var url = "/Approval/GetPOPendingGetAttachments?headerUniqueAttchID=" + headerUniqueAttchID + "&itemUniqueAttchID=" + itemUniqueAttchID;
    return this.http.get(url).toPromise();
  }

  getVPAttachmentPDF(attachmentID: number){
    var url = "/Approval/GetVPAttachmentPDF?attachmentID=" + attachmentID;
    return this.http.get(url).toPromise();
  }

  getVCMAttachment(contentTypeName, docID, filename){
    var url = "/Document/GetVCMAttachment?contentTypeName=" + contentTypeName + "&docID=" + docID + "&filename=" + filename + "&isViewer=true";
    return this.http.get(url).toPromise();
  }
}

export interface PendingPO {
  SourceView: string;
  Company?: number;
  PO: string;
  POItem?: number;
  ItemDescription: string;
  Vendor: number;
  VendorName: string;
  OrderDate?: string;
  OrderDateDisplay?: string;
  OrderedBy: string;
  OrigCost?: number;
  OriginalCostDisplay: number;
  Notes: string;
  POPPKeyID: number;
  ProcessHeaderID: number;
  FormName: string;
  ProcessDetailKeyID: number;
  ItemUniqueAttchID?: string;
  HeaderUniqueAttchID?: string;
  ChargeTo: string;
  ItemType?: number;
  ItemTypeDesc: string;
  POPIKeyID?: number;
  IsLastApprover?: boolean;
  CreatedByFullName: string;
  POSLType: string;
  Selected?: boolean;
}

export interface POPendingUpdateStatus {
  POPPKeyID: number | null;
  PO: string;
  IsFullyApproved?: boolean | null;
  PMCo: number | null;
  Project: string;
  SL: string;
}

export interface POPendingUpdateStatusResponse extends ApiResponse {
  response: POPendingUpdateStatusResponseData
}

export interface POPendingUpdateStatusResponseData {
  returnData: POPendingUpdateStatus[],
  exceptionCount: number,
  failedUpdates: { [key: number]: boolean } | null
}